import styled from 'styled-components';
import suitcase from 'components/shared/Icon/icons/suitcase.svg';

const ListItem = styled.li`
  margin-bottom: 15px;
  font-size: var(--font-size-s);
  color: var(--color-primary);
  line-height: var(--line-height-list);
  padding-left: 2em;
  font-weight: 300;
  position: relative;
  &:before {
    top: 1px;
    left: 7px;
    position: absolute;
    content: '';
    background: url(${suitcase}) no-repeat 0 0;
    color: var(--color-primary);
    display: inline-block;
    background-size: contain;
    width: 1em;
    height: 1em;
    }
`;

export default ListItem;
